import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  TourPriceDto,
  TourPriceWriteDto,
} from '@/features/dashboard/tourConfig/types/TourPriceDto.ts';

const tourPricesApi = {
  writePrices: async (tourPricesDto: TourPriceWriteDto): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      `tours/${tourPricesDto.tourId}/prices`,
      tourPricesDto,
    );
  },
  getPrices: async (tourId: string): Promise<TourPriceDto[]> => {
    return await fetchPrivateApi<TourPriceDto[]>(
      'GET',
      `tours/${tourId}/prices`,
    );
  },
};

export default tourPricesApi;
